/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Breadcrumbs } from '@coursera/cds-core';

import { type SkillEntity } from 'bundles/browse-common/types/Skill';
import { toDomainUrl } from 'bundles/browse-common/utils/domain-utils';
import { toSkillUrl } from 'bundles/browse-common/utils/skill-utils';

type Props = {
  entity: SkillEntity;
};

const SkillBreadcrumbsComponent = (props: Props) => {
  const {
    entity: { domain, skill, skillPath },
  } = props;

  return (
    <Breadcrumbs variant="link">
      <Breadcrumbs.Item href={toDomainUrl(domain.slug)}>{domain.name}</Breadcrumbs.Item>
      {skillPath.map((path) => (
        <Breadcrumbs.Item key={path.id} href={toSkillUrl(path)}>
          {path.skillName}
        </Breadcrumbs.Item>
      ))}
      <Breadcrumbs.Item href={toSkillUrl(skill)}>{skill.skillName}</Breadcrumbs.Item>
    </Breadcrumbs>
  );
};

export default SkillBreadcrumbsComponent;
